import BaseListagem from "components/BaseListagem";
import { FilterMatchMode, FilterOperator } from "primereact/api";
import { Column } from "primereact/column";
import { DataTableFilterMeta } from "primereact/datatable";
import { useState } from "react";
import { useSearchParams } from "react-router-dom";
import OperacaoProducaoService from "service/meta/producao/OperacaoProducaoService";
import { NumberMatchModeOptions, TextMatchModeOptions, filterApplyTemplate, numberFilterTemplate } from "utils/filterUtils";

const operacaoProducaoService = new OperacaoProducaoService();

export default function OperacaoProducaoListagem() {

    const [queryParameters] = useSearchParams();

    const [titulo, setTitulo] = useState<string>('Operações');

    const defaultFilters: DataTableFilterMeta = {
        descricao: {
            constraints: [
                {
                    value: '',
                    matchMode: FilterMatchMode.STARTS_WITH,
                }
            ],
            operator: FilterOperator.AND
        },
        quantidadeOperadores: {
            constraints: [
                {
                    value: null,
                    matchMode: FilterMatchMode.EQUALS,
                }
            ],
            operator: FilterOperator.AND
        },
    }


    return (

        <BaseListagem ordenacao="descricao,ASC" service={operacaoProducaoService} urlService="/operacaoProducao" tituloPagina={titulo} defaultFilters={defaultFilters} showClearFilterButton nome="operacaoProducao" >
            <Column field="descricao" header="Descrição" filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={TextMatchModeOptions} filterApply={filterApplyTemplate} />
            <Column field="quantidadeOperadores" header="Quantidade Operadores" style={{width: 300}} filter showFilterOperator={false} showAddButton={false} filterPlaceholder="Escreva o filtro"
                filterMatchModeOptions={NumberMatchModeOptions} filterApply={filterApplyTemplate} filterElement={numberFilterTemplate} />
        </BaseListagem>
    )
}